export default "__VITE_ASSET__Dzpz7Xr___"